import CoreAPIService from './CoreAPIService';

class AuthService {
    apiService;

    constructor() {
        this.apiService = new CoreAPIService();
    }

  async editMyInfo(data) {
        return this.apiService.patch(`/users/update/${data.id}`, data.data);
    }

    async duplicateNicknameCheck(data) {
        return this.apiService.get(`/users/check-nickname`, data);
    }


}

export default new AuthService();